export enum FeatureName {
  AUTH_DAPP = 'auth-dapp'
}
